import React from 'react';
import {classReducer} from 'utils/helpers';
import Button from 'features/generic/components/Button/Button';

import * as styles from './styles';

const SubmitButton = (props) => {
    const {
        handleClick = () => null,
        submitText = 'Submit',
        submittingText = 'Submitting...',
        successText = 'Submitted!',
        failText = 'Failed',
    } = props;
    const hasSucceeded = props.submitSucceeded && props.valid;
    const hasFailed = props.submitFailed && (props.error || !props.valid);
    const hasSubmitted = hasSucceeded || hasFailed;

    let text = props.submitting ? submittingText : submitText;

    if (hasSubmitted) {
        text = props.submitSucceeded ? successText : failText;
    }

    let disabled = false;

    if (hasSubmitted) {
        disabled = !(props.submitSucceeded && props.valid);
    } else {
        disabled = props.disabled || props.submitting || props.pristine;
    }

    return (
        <button
            style={styles.button(props)}
            onClick={handleClick}
            onMouseUp={props.handleMouseUp}
            disabled={disabled}
            type="submit">
            {text}
        </button>
    );
};

export default SubmitButton;
